module.exports = __webpack_public_path__ + "src/assets/img/okko.c4c096cd.jpg";